import React from 'react'
import axios from 'axios'

import '../App.css'

const directionArr = [
  6, 7 ,8 ,
  5, 10, 1,
  4, 3, 2
]

const Wheel = () => {

  const handleTouchStart = (value) => {
    request(value)
  };

  const onTouchEnd = () => {
    request(0);
  }

  const request = (value) => {
    const urlParams = new URLSearchParams(window.location.search);

    const data = {
      hid: urlParams.get('hid'),
      cid: urlParams.get('cid'),
      dir: value
    };

    if(value !== 10) {
      axios({
        method: 'post',
        url: 'https://iot.univertech.cn/house/live/ctrl',
        data: JSON.stringify(data),
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .then((response) => {
        console.log(response.data);
      })
      .catch((error) => {
        console.error(error);
      });
    }
  }

  return (
    <div className="wheel-container">
      {directionArr.map((item) => (
        <div className="direction-item" key={item} onTouchStart={() => handleTouchStart(item)} onTouchEnd={onTouchEnd} >
          <span className="direction-icon"></span>
        </div>
      ))}
    </div>
  )
}

export default Wheel;